import { render, staticRenderFns } from "./thong-bao-item.vue?vue&type=template&id=01cc4712"
import script from "./thong-bao-item.vue?vue&type=script&lang=js"
export * from "./thong-bao-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports